import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141c733c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-listing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "patient-listing__without-patient" }, "Без пациента", -1))
const _hoisted_3 = { class: "patient-listing__report-count" }
const _hoisted_4 = { class: "divider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_e_patient_card = _resolveComponent("e-patient-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "patient-listing__item",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChoosePatient(0)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["patient-listing__item-content", {
          'patient-listing__item-content--active': _ctx.activePatientId === 0,
        }])
      }, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.patientList.withoutPatientCount) + " " + _toDisplayString(_ctx.signature), 1)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_divider)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientList.patients, (patient) => {
      return (_openBlock(), _createBlock(_component_e_patient_card, {
        key: patient.id,
        active: _ctx.activePatientId === patient.id,
        patient: patient,
        onClick: ($event: any) => (_ctx.handleChoosePatient(patient.id))
      }, null, 8, ["active", "patient", "onClick"]))
    }), 128))
  ]))
}